import { isEqual } from 'lodash-es';
import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';
import { type ActiveMediaTypeParams } from '../types.ts';
import { useActivePreviewParams } from './useActivePreviewParams.ts';

export const useActivePreview = (): [
  ActiveMediaTypeParams | undefined,
  Dispatch<SetStateAction<ActiveMediaTypeParams | undefined>>,
] => {
  const [activePreviewParams, setActivePreviewParams] = useActivePreviewParams();
  const [activePreview, setActivePreview] = useState<ActiveMediaTypeParams | undefined>(activePreviewParams);

  useEffect(() => {
    if (!isEqual(activePreviewParams, activePreview)) {
      setActivePreviewParams(activePreview);
    }
  }, [activePreview?.id, activePreview?.type]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!isEqual(activePreviewParams, activePreview)) {
      setActivePreview(activePreviewParams);
    }
  }, [activePreviewParams?.id, activePreviewParams?.type]); // eslint-disable-line react-hooks/exhaustive-deps

  return [activePreview, setActivePreview];
};
